/** @jsxImportSource @emotion/react */
import './bootstrap';
import React from 'react';
import UnauthenticatedApp from './unauthenticated-app';
import AuthenticatedApp from './authenticated-app';
import {AuthProvider, useAuth} from './context/auth-context';
import { ToastContainer } from '@mayo/mayo-ui-gakki';

export function GakkiManagementApp() {
  const {user} = useAuth();
  return user ? <AuthenticatedApp /> : <UnauthenticatedApp />;
}

export default function Root() {
  return (
    <AuthProvider>
      <GakkiManagementApp />
      <ToastContainer/>
    </AuthProvider>
  );
}
